import React from "react";
import { Box, Typography } from "@bca/ui-library";

import ZeroSalesSVG from "../Icons/ZeroSalesSVG";

const ZeroSales = () => {
  return (
    <Box
      width="300px"
      height="400px"
      display="flex"
      flexDirection="column"
      margin="0 auto"
      alignItems="center"
      justifyContent="center"
    >
      <ZeroSalesSVG width="64px"></ZeroSalesSVG>
      <Typography
        variant="h4"
        marginTop="16px"
        marginBottom="12px"
        textAlign="center"
        color="#060916"
      >
        No Sales Planned
      </Typography>
      <Typography
        variant="h6"
        marginTop="16px"
        textAlign="center"
        margin="0"
        color="#64798c"
        css="font-weight: 400"
      >
        There are currently no sales planned on this day.
      </Typography>
    </Box>
  );
};

export default ZeroSales;
